import { render, staticRenderFns } from "./downMt4Dialog.vue?vue&type=template&id=3895c3fe&scoped=true"
import script from "./downMt4Dialog.vue?vue&type=script&lang=js"
export * from "./downMt4Dialog.vue?vue&type=script&lang=js"
import style0 from "./downMt4Dialog.vue?vue&type=style&index=0&id=3895c3fe&prod&lang=css"
import style1 from "./downMt4Dialog.vue?vue&type=style&index=1&id=3895c3fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3895c3fe",
  null
  
)

export default component.exports